// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-filter[data-v-1d54d80f]{width:100%;position:relative}.search-filter .no-results[data-v-1d54d80f]{position:absolute;margin-top:.25rem;z-index:1;top:100%;left:0;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
